@if (isLoading) {
<!-- Skeleton loading -->
<div class="ion-padding content-width">
  <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
  <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
  <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
</div>
<div class="ion-padding content-width">
  <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
  <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
  <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
</div>
<div class="ion-padding content-width">
  <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
  <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
  <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
</div>
} @else {
@if (!followers?.length) {
<!-- Empty state -->
<app-empty-page class="content-width" text="{{'There are not any fans for this team' | translate}}" iconName="people">
</app-empty-page>
} @else {
<!-- Followers list -->
<ion-list class="content-width">
  <div class="fan-count-wrapper">
    <div class="fan-count">{{followers?.length}}</div>
  </div>
  @for (fan of followers; track $index) {
  <ion-item>
    <ion-avatar slot="start">
      <img [src]="fan.profile_image ? fan.profile_image : avatarImage" [alt]="fan.first_name + ' ' + fan.last_name" />
    </ion-avatar>
    <ion-label>
      <h2>{{ fan.first_name }} {{ fan.last_name }}</h2>
      <p *ngIf="fan | displayValue as value">{{ value }}</p>
    </ion-label>
  </ion-item>
  }
</ion-list>
}
}